import * as types from './types';

export const contactFileMutations = {
  [types.ContactFiles.SET.ALL](state, payload) {
    state.contactFiles = payload;
    state.selectedContact.files=payload;
  },
  [types.ContactFilesSearchResult.SET.ALL](state, payload) {
    state.contactFilesSearchResult = payload;
  },
  [types.SET_CONTACT_FILES_LIST_START_ROW](state, startRow) {
    state.contactFilesStart = startRow;
  },


  
}